// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1NYFb","powered-by":"Footer_powered-by__3-I_F","privacy-policy":"Footer_privacy-policy__1zZCh","copyright":"Footer_copyright__2YX5o"};